import { getItem } from '@/utils/storage'

export interface WebSocketMessage {
  type: 'device_data' | 'alarm' | 'device_status' | 'program_status'
  deviceId?: string
  data?: any
  timestamp?: number
}

type MessageHandler = (msg: WebSocketMessage) => void

class HeatingWebSocket {
  private ws: WebSocket | null = null
  private handlers: MessageHandler[] = []
  private reconnectTimer: ReturnType<typeof setTimeout> | null = null
  private url = ''

  connect() {
    const token = getItem('token')
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    const host = window.location.host
    this.url = `${protocol}//${host}/ws/heating?token=${token}`

    this.ws = new WebSocket(this.url)

    this.ws.onopen = () => {
      console.log('[HeatingWS] Connected')
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer)
        this.reconnectTimer = null
      }
    }

    this.ws.onmessage = (event) => {
      try {
        const msg: WebSocketMessage = JSON.parse(event.data)
        this.handlers.forEach(h => h(msg))
      } catch (e) {
        // ignore non-JSON
      }
    }

    this.ws.onclose = () => {
      console.log('[HeatingWS] Disconnected, reconnecting in 5s...')
      this.reconnectTimer = setTimeout(() => this.connect(), 5000)
    }

    this.ws.onerror = () => {
      this.ws?.close()
    }
  }

  disconnect() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = null
    }
    this.ws?.close()
    this.ws = null
  }

  onMessage(handler: MessageHandler) {
    this.handlers.push(handler)
    return () => {
      this.handlers = this.handlers.filter(h => h !== handler)
    }
  }

  send(data: any) {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(data))
    }
  }
}

export const heatingWs = new HeatingWebSocket()
